var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.freightServices),function(freightService){return _c('div',{key:freightService.id},[_c('base-label-with-freight-service',{attrs:{"freight-service":freightService}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }